<ng-content></ng-content><div class="button-effect"></div>